import { createSlice } from'@reduxjs/toolkit';
export const stateSlice = createSlice({
    name: 'state',
    initialState: {},
    reducers: {
       
       userRegister: (state, action) => {
  return {...state, userData: action.payload} // La incluimos en el arreglo de tareas de nuestro estado.
}
    },
  });
// Exportamos los actions desde el slice que acabamos de crear:
export const { userRegister } = stateSlice.actions;

// Por defecto exportamos la propiedad reducer desde el slice que acabamos de crear:
export default stateSlice.reducer;
